import type { CartExperimentConfig } from './resolver';

/** 后端已确认的四组参数；不得复用旧自动优惠实验。 */
export const CART_EXPERIMENT_PARAM_NAME = 'is_Cart_Version';

/** 前端契约修订，用于解析缓存隔离；不是实验平台返回的版本号。 */
export const CART_EXPERIMENT_CONFIG = {
  enabled: true,
  paramName: CART_EXPERIMENT_PARAM_NAME,
  revision: 'cart-version-v1',
} as const satisfies CartExperimentConfig;
